import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('catalog-filter-multiple', () => import(/* webpackMode: "lazy" */'./catalog-filter-multiple'));
